import React ,{ useEffect} from "react";
import { Link } from "react-router-dom";

export default function CheckoutFailed() {
  useEffect(() => {
    document.title = "Failed | Workgear365";
  }, []);
  return (
    <div className="container">
      <style>{`
        #cancel {
          text-align: center;
          padding: 50px;
          background-color: white;
          box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
          max-width: 600px;
          margin: 50px auto;
        }
        #cancel h1 {
          color: #28a745; /* same as your Blade example */
          font-size: 36px;
          margin-bottom: 16px;
        }
        #cancel p {
          color: #333;
          font-size: 18px;
          margin-bottom: 24px;
        }
        #cancel .btn-success-like {
          background-color: #28a745;
          color: #fff;
          padding: 10px 20px;
          text-decoration: none;
          font-size: 16px;
          border-radius: 5px;
          border: none;
          display: inline-block;
          margin: 0 8px;
          transition: background-color 0.3s ease;
        }
        #cancel .btn-success-like:hover {
          background-color: #218838;
          color: #fff;
        }
      `}</style>

      <div id="cancel">
        <h1>Payment Canceled</h1>
        <p>Your payment has been canceled. If this was a mistake, please try again.</p>

        {/* Helpful actions */}
        <div>
          <Link to="/cart" className="btn-success-like">Back to Cart</Link>
          <Link to="/" className="btn-success-like">Go Home</Link>
        </div>
      </div>
    </div>
  );
}
